import cx from "classnames";
import GptAd, { GptAdProps } from "./GptAd";
import styles from "./HousePromo.module.scss";

// Adds a way to describe margins, padding, or other context-based styles
interface HousePromoProps extends GptAdProps {
  isSwan?: boolean;
}

const HousePromo = ({ className, isSwan, ...props }: HousePromoProps) => {
  return (
    <GptAd
      className={cx(
        styles.root,
        isSwan ? styles.swanInjected : null,
        className
      )}
      format="promo"
      sizesAt0="house"
      {...props}
    />
  );
};

export default HousePromo;
